module.exports = __webpack_public_path__ + "img/loading_027AFF.92496eb9.svg";